export interface IShapeFilter {
    showDevicesOnMap?: boolean;
    showSpotsOnMap?: boolean;
    showDetectionZonesOnMap?: boolean;
    showScreenLinesOnMap?: boolean;
    showLaneLinesOnMap?: boolean;
    showReferencePointOnMap?: boolean;

    showDevicesInConfig?: boolean;
    showSpotsInConfig?: boolean;
    showDetectionZonesInConfig?: boolean;
    showScreenLinesInConfig?: boolean;
    showLaneLinesInConfig?: boolean;
    showReferencePointInConfig?: boolean;
}

export class ShapeFilter implements IShapeFilter {
    showDevicesOnMap: boolean;
    showSpotsOnMap: boolean;
    showDetectionZonesOnMap: boolean;
    showScreenLinesOnMap: boolean;
    showLaneLinesOnMap: boolean;
    showReferencePointOnMap: boolean;

    showDevicesInConfig: boolean;
    showSpotsInConfig: boolean;
    showDetectionZonesInConfig: boolean;
    showScreenLinesInConfig: boolean;
    showLaneLinesInConfig: boolean;
    showReferencePointInConfig: boolean;

    constructor(options?: IShapeFilter) {
        this.showDevicesOnMap = options?.showDevicesOnMap ?? true;
        this.showSpotsOnMap = options?.showSpotsOnMap ?? true;
        this.showDetectionZonesOnMap = options?.showDetectionZonesOnMap ?? true;
        this.showScreenLinesOnMap = options?.showScreenLinesOnMap ?? true;
        this.showLaneLinesOnMap = options?.showLaneLinesOnMap ?? true;
        this.showReferencePointOnMap = options?.showReferencePointOnMap ?? true;

        this.showDevicesInConfig = options?.showDevicesInConfig ?? true;
        this.showSpotsInConfig = options?.showSpotsInConfig ?? true;
        this.showDetectionZonesInConfig = options?.showDetectionZonesInConfig ?? true;
        this.showScreenLinesInConfig = options?.showScreenLinesInConfig ?? true;
        this.showLaneLinesInConfig = options?.showLaneLinesInConfig ?? true;
        this.showReferencePointInConfig = options?.showReferencePointInConfig ?? true;
    }

    static showAll(): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: true,
            showSpotsOnMap: true,
            showDetectionZonesOnMap: true,
            showScreenLinesOnMap: true,
            showLaneLinesOnMap: true,
            showReferencePointOnMap: true,
            showDevicesInConfig: true,
            showSpotsInConfig: true,
            showDetectionZonesInConfig: true,
            showScreenLinesInConfig: true,
            showLaneLinesInConfig: true,
            showReferencePointInConfig: true,
        });
    }

    static showAllOnMapButHideDevicesAndSpotsInConfig(): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: true,
            showSpotsOnMap: true,
            showDetectionZonesOnMap: true,
            showScreenLinesOnMap: true,
            showLaneLinesOnMap: true,
            showReferencePointOnMap: true,
            showDevicesInConfig: false,
            showSpotsInConfig: false,
            showDetectionZonesInConfig: true,
            showScreenLinesInConfig: true,
            showLaneLinesInConfig: true,
            showReferencePointInConfig: true,
        });
    }

    static hideDevicesAndSpotsEverywhere(): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: false,
            showSpotsOnMap: false,
            showDetectionZonesOnMap: true,
            showScreenLinesOnMap: true,
            showLaneLinesOnMap: true,
            showReferencePointOnMap: true,
            showDevicesInConfig: false,
            showSpotsInConfig: false,
            showDetectionZonesInConfig: true,
            showScreenLinesInConfig: true,
            showLaneLinesInConfig: true,
            showReferencePointInConfig: true,
        });
    }

    static onlyDetectionZonesAndScreenLinesEverywhere(): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: false,
            showSpotsOnMap: false,
            showDetectionZonesOnMap: true,
            showScreenLinesOnMap: true,
            showLaneLinesOnMap: false,
            showReferencePointOnMap: false,
            showDevicesInConfig: false,
            showSpotsInConfig: false,
            showDetectionZonesInConfig: true,
            showScreenLinesInConfig: true,
            showLaneLinesInConfig: false,
            showReferencePointInConfig: false,
        });
    }

    clone(): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: this.showDevicesOnMap,
            showSpotsOnMap: this.showSpotsOnMap,
            showDetectionZonesOnMap: this.showDetectionZonesOnMap,
            showScreenLinesOnMap: this.showScreenLinesOnMap,
            showLaneLinesOnMap: this.showLaneLinesOnMap,
            showReferencePointOnMap: this.showReferencePointOnMap,
            showDevicesInConfig: this.showDevicesInConfig,
            showSpotsInConfig: this.showSpotsInConfig,
            showDetectionZonesInConfig: this.showDetectionZonesInConfig,
            showScreenLinesInConfig: this.showScreenLinesInConfig,
            showLaneLinesInConfig: this.showLaneLinesInConfig,
            showReferencePointInConfig: this.showReferencePointInConfig,
        });
    }

    update(options: Partial<IShapeFilter>): ShapeFilter {
        return new ShapeFilter({
            showDevicesOnMap: options.showDevicesOnMap ?? this.showDevicesOnMap,
            showSpotsOnMap: options.showSpotsOnMap ?? this.showSpotsOnMap,
            showDetectionZonesOnMap: options.showDetectionZonesOnMap ?? this.showDetectionZonesOnMap,
            showScreenLinesOnMap: options.showScreenLinesOnMap ?? this.showScreenLinesOnMap,
            showLaneLinesOnMap: options.showLaneLinesOnMap ?? this.showLaneLinesOnMap,
            showReferencePointOnMap: options.showReferencePointOnMap ?? this.showReferencePointOnMap,
            showDevicesInConfig: options.showDevicesInConfig ?? this.showDevicesInConfig,
            showSpotsInConfig: options.showSpotsInConfig ?? this.showSpotsInConfig,
            showDetectionZonesInConfig: options.showDetectionZonesInConfig ?? this.showDetectionZonesInConfig,
            showScreenLinesInConfig: options.showScreenLinesInConfig ?? this.showScreenLinesInConfig,
            showLaneLinesInConfig: options.showLaneLinesInConfig ?? this.showLaneLinesInConfig,
            showReferencePointInConfig: options.showReferencePointInConfig ?? this.showReferencePointInConfig,
        });
    }

    hasHiddenShapesOnMap(): boolean {
        return !this.showDevicesOnMap || !this.showSpotsOnMap || !this.showDetectionZonesOnMap || !this.showScreenLinesOnMap || !this.showLaneLinesOnMap || !this.showReferencePointOnMap;
    }

    hasHiddenShapesInConfig(): boolean {
        return !this.showDevicesInConfig || !this.showSpotsInConfig || !this.showDetectionZonesInConfig || !this.showScreenLinesInConfig || !this.showLaneLinesInConfig || !this.showReferencePointInConfig;
    }

    areAllShapesVisibleOnMap(): boolean {
        return this.showDevicesOnMap && this.showSpotsOnMap && this.showDetectionZonesOnMap && this.showScreenLinesOnMap && this.showLaneLinesOnMap && this.showReferencePointOnMap;
    }

    areAllShapesVisibleInConfig(): boolean {
        return this.showDevicesInConfig && this.showSpotsInConfig && this.showDetectionZonesInConfig && this.showScreenLinesInConfig && this.showLaneLinesInConfig && this.showReferencePointInConfig;
    }

    getVisibleShapeTypeCountOnMap(): number {
        let count = 0;
        if (this.showDevicesOnMap) count++;
        if (this.showSpotsOnMap) count++;
        if (this.showDetectionZonesOnMap) count++;
        if (this.showScreenLinesOnMap) count++;
        if (this.showLaneLinesOnMap) count++;
        if (this.showReferencePointOnMap) count++;
        return count;
    }

    getVisibleShapeTypeCountInConfig(): number {
        let count = 0;
        if (this.showDevicesInConfig) count++;
        if (this.showSpotsInConfig) count++;
        if (this.showDetectionZonesInConfig) count++;
        if (this.showScreenLinesInConfig) count++;
        if (this.showLaneLinesInConfig) count++;
        if (this.showReferencePointInConfig) count++;
        return count;
    }

    toPlainObject(): IShapeFilter {
        return {
            showDevicesOnMap: this.showDevicesOnMap,
            showSpotsOnMap: this.showSpotsOnMap,
            showDetectionZonesOnMap: this.showDetectionZonesOnMap,
            showScreenLinesOnMap: this.showScreenLinesOnMap,
            showLaneLinesOnMap: this.showLaneLinesOnMap,
            showReferencePointOnMap: this.showReferencePointOnMap,
            showDevicesInConfig: this.showDevicesInConfig,
            showSpotsInConfig: this.showSpotsInConfig,
            showDetectionZonesInConfig: this.showDetectionZonesInConfig,
            showScreenLinesInConfig: this.showScreenLinesInConfig,
            showLaneLinesInConfig: this.showLaneLinesInConfig,
            showReferencePointInConfig: this.showReferencePointInConfig,
        };
    }

    static fromPlainObject(obj: IShapeFilter): ShapeFilter {
        return new ShapeFilter(obj);
    }
}
